import CargoCompanyCargoTaxiContractsRequest from "../../../../api/raily/cargo-company/cargo-taxi/contracts/cargo-company-cargo-taxi-contracts.request";
import CargoCompanyCargoTaxiContractsParams from "./cargo-company-cargo-taxi-contracts-params";

const create = (
  params: CargoCompanyCargoTaxiContractsParams,
): CargoCompanyCargoTaxiContractsRequest => {
  return {
    cargoCompanyUuid: params.cargoCompanyUuid,
  };
};

const cargoCompanyCargoTaxiContractsParamsFactory = {
  create,
};

export default cargoCompanyCargoTaxiContractsParamsFactory;
